import(/* webpackMode: "eager", webpackExports: ["AgricultureView"] */ "/opt/buildhome/repo/components/AgricultureView.tsx");
